import axios from 'axios'

/**
 * Cotações da tabela AMÉRICAS (tQuotes_IndAmericas) do Moscca.
 * @returns {Promise<{ brasil: Array<{ name, last, var, varPct, positive }>, eua: Array }>}
 */
export const getMarketQuotes = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/market/quotes`)
  return data
}
